const TURNSTILE_SCRIPT_SELECTOR =
	'script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]';

let turnstileScriptPromise: Promise<void> | null = null;

function waitForTurnstile(resolve: () => void, reject: (err: Error) => void): void {
	let attempts = 0;
	const check = (): void => {
		if (window.turnstile) {
			resolve();
		} else if (attempts > 100) {
			turnstileScriptPromise = null;
			reject(new Error("Turnstile not available after script load"));
		} else {
			attempts++;
			setTimeout(check, 50);
		}
	};
	check();
}

/** Wait for Turnstile from the deferred script tag in index.html. */
export function loadTurnstileScript(): Promise<void> {
	if (typeof window === "undefined") return Promise.resolve();
	if (window.turnstile) return Promise.resolve();
	if (turnstileScriptPromise) return turnstileScriptPromise;

	turnstileScriptPromise = new Promise((resolve, reject) => {
		if (!document.querySelector(TURNSTILE_SCRIPT_SELECTOR)) {
			turnstileScriptPromise = null;
			reject(new Error("Turnstile script tag missing"));
			return;
		}
		waitForTurnstile(resolve, reject);
	});

	return turnstileScriptPromise;
}
